module.exports = __webpack_public_path__ + "static/support-a93e767d1714d232871daaae3bb9d609.png";